import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';
import { toJS } from 'mobx';
import Spinner from '../Spinner';

@inject('locationStore', 'locationTypeStore')
@observer
class LocationList extends Component {
  componentWillMount() {
    const { locationStore, locationTypeStore } = this.props;
    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();
  }

  render() {
    const { children, locationStore, locationTypeStore } = this.props;
    if (locationStore.isLoading || locationTypeStore.isLoading) return <Spinner />

    let data = Object.assign([], toJS(locationStore.items)).map(item => {
      item.type = locationTypeStore.findById(item.type_id);
      item.parent = locationStore.findById(item.parent_id);
      return item
    })


    return (
      <ItemList
        store={locationStore}
        data={data}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name', searchable: true },
          { key: 'description', label: 'Description', searchable: true },
          { key: 'type.name', label: 'Type', searchable: true },
          { key: 'parent.name', label: 'Parent', searchable: true },
        ]}
        slug={'configurations/location/station-location'}
        resource={'configurations'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />

    );
  }
}

export default LocationList;



// WEBPACK FOOTER //
// ./src/components/Location/LocationList.js